import SecurityService from "@/services/v2/common/security.service";
export const securityApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    encrypt({ commit }, val) {
      return SecurityService.encrypt(val).then(
        (resp) => {
          commit("dummyConsole", "SecurityService.encrypt - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "SecurityService.encrypt - error");
          return Promise.reject(error);
        }
      );
    },

    decrypt({ commit }, val) {
      return SecurityService.decrypt(val).then(
        (resp) => {
          commit("dummyConsole", "SecurityService.decrypt - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "SecurityService.decrypt - error");
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
